import API from "./index"

export const createNewPerformance = (data) => API.post(`/performances`, data)